import React from 'react';
import helper from 'components/utils/helper';
import { Container } from 'themes/MoGrid';
import { Wrapper } from './RichTextBlock.style';

const RichTextBlock = ({richTextBlock}) => {
    return (
        <Container>
            <Wrapper>{richTextBlock && helper.renderParagraph(richTextBlock)}</Wrapper>
        </Container>
    );
}
 
export default RichTextBlock;